console.log('🔍 Wishlist reposition script loaded - Version 4.8 (Klaviyo)!');

var wishlistRepositioned = false;
var repositionAttempts = 0;
var maxAttempts = 20;
var isProcessing = false;

// 查找 wishlist widget（只找 product__info-container 里的）
function findWishlistWidget() {
  var selectors = [
    '.klaviyo-wishlist-slot',
    '.k1-hub-favorites-slot',
    '[class*="klaviyo-wishlist"]',
    '[class*="k1-hub-favorites"]'
  ];
  
  for (var i = 0; i < selectors.length; i++) {
    var widget = document.querySelector('.product__info-container ' + selectors[i]);
    if (widget) {
      console.log('✅ Found wishlist widget:', selectors[i]);
      return widget;
    }
  }
  
  return null;
}

// 主要的重定位函数
function repositionWishlist() {
  if (wishlistRepositioned) {
    console.log('⏭️ Already repositioned, skipping');
    return true;
  }
  
  if (isProcessing) {
    console.log('⏭️ Already processing, skipping');
    return false;
  }
  
  isProcessing = true;
  
  repositionAttempts++;
  console.log('🔄 Reposition attempt #' + repositionAttempts);
  
  var widget = findWishlistWidget();
  
  if (!widget) {
    console.log('❌ Wishlist widget not found');
    isProcessing = false;
    
    if (repositionAttempts < maxAttempts) {
      console.log('⏳ Retrying in 500ms...');
      setTimeout(repositionWishlist, 500);
    } else {
      console.log('⏱️ Max attempts reached, stopping');
    }
    return false;
  }

  // 检查 Klaviyo 是否已经渲染了按钮
  var klaviyoBtn = widget.querySelector('button');
  if (!klaviyoBtn) {
    console.log('⏳ Klaviyo button not rendered yet, retrying...');
    isProcessing = false;
    if (repositionAttempts < maxAttempts) {
      setTimeout(repositionWishlist, 500);
    }
    return false;
  }
  
  var isMobile = window.innerWidth < 750;
  console.log('📱 Device type:', isMobile ? 'Mobile' : 'Desktop', '| Width:', window.innerWidth);
  
  try {
    var success = false;
    if (isMobile) {
      success = repositionForMobile(widget);
    } else {
      success = repositionForDesktop(widget);
    }
    
    isProcessing = false;
    return success;
    
  } catch (error) {
    console.error('❌ Error during reposition:', error);
    isProcessing = false;
    return false;
  }
}

// 移动端处理：创建触发器，点击时触发原始 Klaviyo 按钮，并同步状态
function repositionForMobile(widget) {
  var stickyContainer = document.querySelector('#sticky-wishlist-container');
  
  if (!stickyContainer) {
    console.log('❌ Sticky container not found');
    return false;
  }

  // 如果已经有触发器，跳过
  if (stickyContainer.querySelector('.sticky-wishlist-trigger')) {
    console.log('✅ Trigger already exists');
    wishlistRepositioned = true;
    return true;
  }

  if (stickyContainer.children.length > 0) {
    stickyContainer.innerHTML = '';
  }

  // 隐藏原始 wishlist block（buy btn 右侧那个）
  var originalBlock = widget.closest('.product__block') || widget.closest('.shopify-block');
  if (originalBlock && originalBlock.closest('.product__info-container')) {
    originalBlock.style.display = 'none';
    console.log('✅ Original wishlist hidden');
  }

  // 创建触发器
  var trigger = document.createElement('button');
  trigger.className = 'sticky-wishlist-trigger';
  trigger.type = 'button';
  trigger.innerHTML = widget.innerHTML;

  // 点击时触发原始 Klaviyo 按钮
  trigger.addEventListener('click', function() {
    var originalBtn = widget.querySelector('button');
    if (originalBtn) {
      originalBtn.click();
      console.log('✅ Triggered original Klaviyo button');
    }
  });

  // 监听原始 widget 变化，同步状态到 trigger
  var observer = new MutationObserver(function() {
    trigger.innerHTML = widget.innerHTML;
    console.log('✅ Trigger synced with original widget');
  });

  observer.observe(widget, {
    childList: true,
    subtree: true,
    attributes: true
  });

  stickyContainer.appendChild(trigger);
  wishlistRepositioned = true;
  console.log('✅ Mobile: Trigger added to sticky bar');
  return true;
}

// 桌面端处理
function repositionForDesktop(widget) {
  var buttonContainer = document.querySelector('.product__info-container .product-form__buttons');
  
  if (!buttonContainer) {
    console.log('❌ Button container not found');
    return false;
  }
  
  if (buttonContainer.contains(widget)) {
    console.log('✅ Wishlist already in button container');
    wishlistRepositioned = true;
    return true;
  }
  
  console.log('💻 Moving wishlist to button container...');
  
  var widgetBlock = widget.closest('.product__block') || widget.closest('.shopify-block') || widget;
  
  buttonContainer.appendChild(widgetBlock);
  buttonContainer.classList.add('has-wishlist-button');
  widgetBlock.classList.add('wishlist-in-button-row');
  
  wishlistRepositioned = true;
  console.log('✅ Desktop: Wishlist successfully moved to button row!');
  return true;
}

// 窗口大小改变处理
var resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    console.log('📐 Window resized:', window.innerWidth);

    wishlistRepositioned = false;
    repositionAttempts = 0;
    isProcessing = false;

    // 清空 sticky container
    var stickyContainer = document.querySelector('#sticky-wishlist-container');
    if (stickyContainer) {
      stickyContainer.innerHTML = '';
    }

    repositionWishlist();
  }, 300);
});

// 防止滚动触发重复执行
var scrollBlocked = false;
window.addEventListener('scroll', function() {
  if (!scrollBlocked && wishlistRepositioned) {
    scrollBlocked = true;
    console.log('🚫 Scroll detected, but reposition already done');
  }
});

// 初始化
function init() {
  console.log('⏰ Initializing in 1.5 seconds...');
  
  setTimeout(function() {
    console.log('🚀 Starting wishlist reposition...');
    repositionWishlist();
  }, 1500);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}